import { Observable } from "rxjs";
import { apiService } from "../../ApiService";
import { Plan } from "../../../model/Plan";

export const getAllPlans = (): Observable<Plan[]> => {
  // TODO Api URL to return Real plan
  return apiService.get({
    path: `v1/plans`,
  });
};
